import { Controller } from '@hotwired/stimulus'

const POLL_INTERVAL = 5000

export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: POLL_INTERVAL } };

  connect () {
    this.timer = setInterval(() => this.reload(), this.intervalValue)
  }

  disconnect () {
    clearInterval(this.timer)
  }

  reload () {
    const frame = this.element.closest('turbo-frame')
    if (frame && this.urlValue) {
      // Clear src first (as Turbo's own frame.reload() does) so that
      // re-assigning the same URL is always treated as a new navigation.
      frame.src = null
      frame.src = this.urlValue
    }
  }
}
